import React from 'react'
import classNames from 'classnames'
import { IconCircle, IconCircleCheck } from '@tabler/icons-react'

export const PasswordRequirement = ({ requirements, criteria, children }) => {
  return (
    <div
      data-testid={requirements[criteria] ? 'pass' : 'fail'}
      className={classNames('flex', 'small-gap', {
        'status-success': requirements[criteria],
        'muted-text': !requirements[criteria],
      })}
    >
      {requirements[criteria] ? <IconCircleCheck size={16} /> : <IconCircle size={16} />}
      <div>{children}</div>
    </div>
  )
}
